import { URL } from "./var";

const music = [
  {
    nev: "Ellopták a velőscsontom",
    loc: `${URL}/music/elloptakaveloscsontom.mp3`,
    duration: 225,
    lyrics: [
      "Jó dolga van bizonyára mindennap az ebnek,\n" +
        "kit gazdája egy jó velőscsonttal lep meg,\n" +
        "cupákos, húsdarabos, szalonnás és meleg,\n" +
        "ettől minden fajtársnak az orrcimpája remeg.\n" +
        "Történt ilyen nem túl régen hó hóhahó,\n" +
        "utcavégen éldegélt egy kanapélábú kopó,\n" +
        "rámosolygott egy nap a bitang szerencse,\n" +
        "gazdaasszony velőscsonttal jól meglepte.\n",

      "Szuper nap ez nagyon hó hóhahó,\n" +
        "így gondolkodott a kanapélábú kopó.\n ",

      "Kétlábra állt, körbeforgott, \n" +
        "összevissza ámuldozott, \n" +
        "felkapta a velőscsontját, \n" +
        "csattogtatta már a fogát, \n" +
        "morgás közben falatozott, \n" +
        "közben biz nem ugrándozott, \n" +
        "megtömte jól a bendőjét, \n" +
        "elővette zsebkendőjét, \n" +
        "beletörölte a száját, \n" +
        "végignézte a munkáját, \n" +
        "maradt rajta még mit enni, \n" +
        "rossz napokra el kell tenni. \n",

      "Szuper nap ez nagyon hó hóhahó,\n" +
        "így gondolkodott a kanapélábú kopó.\n ",

      "Hová ássam, hová tegyem, hol legyen a helye, \n" +
        "jajj csak ne a kertben, mert az mindennek a teteje. \n" +
        "Az asszonyom szólott múltkor, \n" +
        "ne ássál már, sok a jóból, \n" +
        "bizony akkor hová rakjam, \n" +
        "sok tolvaj van az udvarban.",

      "Szuper nap ez nagyon hó hóhahó,\n" +
        "így gondolkodott a kanapélábú kopó.\n ",

      "Elásom jól a pitvarban a kerítés mellé,\n" +
        "ebbe bizony senkise nem köthet belé. \n" +
        "Meg is történt azon nyomban az elásó művelet, \n" +
        "kopónk joggal úgy érezte, ez a fő műve lett. \n",

      "Szuper nap ez nagyon hó hóhahó,\n" +
        "így gondolkodott a kanapélábú kopó.\n ",

      "Kedves kopónk másnap újra megéhezett, \n" +
        "korán reggel peckesen a pitvarba lépkedett, \n" +
        "egy kiadós finom reggelire vágyott, \n" +
        "a kiásásnak mán jelleggel jól neki is látott. \n" +
        "Kaparok, kutatok serényen, \n" +
        "meglesz az eledelem remélem.\n",

      "Szuper nap ez nagyon hó hóhahó,\n" +
        "így gondolkodott a kanapélábú kopó.\n ",

      "Az eredmény azonban kiborító lett, \n" +
        "eltűnt a csont, micsoda borzalmas tett. \n" +
        "A csont helyén kopónkat csak egy üzenet várta, \n" +
        "„Köszi a csontot kopó báttya!” \n" +
        "Még aláírni sem volt a gazfickó rest, \n" +
        "üdvözöl téged a tolvaj nyest! \n" +
        "Kopónk sírva vonyított fel, \n" +
        "bundádat te bitang nyest, egy ember vegye fel!\n",

      "Szuper nap ez nagyon hó hóhahó,\n" +
        "így gondolkodott a kanapélábú kopó.\n ",
    ],
  },
  {
    nev: "Megugattam a postást kétszer",
    loc: `${URL}/music/megugattamapostast.mp3`,
    duration: 154,
    lyrics: [
      "Megugattam a postást kétszer, \n" +
        "mert rám ijesztett egy cserépléccel, \n" +
        "Vaúúúú\n" +
        "Éppen szépen szundikáltam, \n" +
        "álmomban a menyországban, \n" +
        "finom csontot nyalogattam, \n" +
        "tepertőbőrt ropogtattam, \n" +
        "szertefoszlott jajj az álmom, \n" +
        "ezen a szép délutánon.\n",

      "Tepertőbőr, velőscsont, mi sem remekebb, \n" +
        "erről álmodik minden rendes eb.\n" +
        "Tepertőbőr, velőscsont, mi sem remekebb, \n" +
        "erről álmodik minden rendes eb.\n",

      "Látom, hogy a ház felé egy zöldruhás ember tart, \n" +
        "s kezével egy nagy táskában valamit kavart.\n" +
        "Mit is csinál ilyenkor a jó házőrző eb, \n" +
        "támadásba lendül, mi sem természetesebb.\n" +
        "Ugatás, morgás és félelmetes hang, \n" +
        "a zöldruhás ember rögtön megtorpant,\n" +
        "azonnal körbenézett, védelmet keresett, \n" +
        "keze ügyébe egy cserépléc esett.\n" +
        "Felkapta és meglóbálta, \n" +
        "közben vadul kiabálta, \n" +
        "tűnés innen ádáz bestia, \n" +
        "vagy nem jut leveléhez még ma a gazda.\n",

      "Ó, a postást megugatni kötelező tett, \n" +
        "feladatul minden ebnek ez rendeltetett.\n" +
        "Ó, a postást megugatni kötelező tett, \n" +
        "feladatul minden ebnek ez rendeltetett.\n",

      "A ribilliót ó a gazda is meghallotta, \n" +
        "szerénységem az udvarra kiparancsolta.\n" +
        "Mit tehettem, ő a főnök, ezt megértettem, \n" +
        "a kötelező feladatom már elvégeztem.\n" +
        "Kézcsók, viszlát Mari néni – szólott a postás, \n" +
        "kattant a kertkapu, újra szabad volt a támadás,\n" +
        "kertkapuhoz rohantam szélvész sebességgel, \n" +
        "megugattam újra legnagyobb természetességgel.\n",

      "Megugattam a postást kétszer mert felébresztett, \n" +
        "ez minden ebnek kötelező tett.\n" +
        "Megugattam a postást kétszer mert felébresztett, \n" +
        "ez minden ebnek kötelező tett.\n",
    ],
  },
];

export const questMusic = [
  {
    nev: "Karmosi úr",
    lyrics: [
      [
        "      Élt egy kis macska, Karom volt a neve,\n" +
          "a falusi porta volt a kedvenc terepe.\n" +
          "Gazda, tyúkok, kacsák, és egy öreg kutya,\n" +
          "mind jól ismerték, hogy csintalan figura.\n",

        "Egy nap elkóborolt, kutya kergette,\n" +
          "majd egy okos sünlány hazaterelte.\n" +
          "Megkomolyodott, megjavult iskolába járt,\n" +
          "okos kis fejében sok jó dolgot kitalált. \n" +
          "Karmosi úr lett végül, így szólították,\n" +
          "büszkék is voltak rá a régi cimborák.\n",

        "Karom, Karmosi, Karmosi Úr!\n" +
          "A nebulók fejébe tudást gyúr!\n" +
          "Macskolában ma már ő a tanár,\n" +
          "az iskolába mindenki örömmel jár.\n",

        "Hiperszuper gépet ő megalkotott,\n" +
          "ezzel egy kiállításra ki is jutott.\n" +
          "MIAUS-1 volt a találmány neve,\n" +
          "robot, mi minden munkát elvégez helyette.\n" +
          "Porszívózik, varr és fát is hasogat,\n" +
          "legyen idő olvasni, s alkotni nagyokat.\n",
      ],

      [
        "A messzi kiállításon párra is talált,\n" +
          "összeházasodtak, együtt hordtak talárt.\n" +
          "Nemsokára öt fős lett a Karmosi család,\n" +
          "be is laktak szépen egy takaros tanyát.\n",

        "Karom, Karmosi, Karmosi Úr!\n" +
          "A nebulók fejébe tudást gyúr!\n" +
          "Macskolában ma már ő a tanár,\n" +
          "az iskolába mindenki örömmel jár.\n",

        "Esténként a kismacsekok mesét hallgattak,\n" +
          "melyek Karmosi úr fejéből kipattantak.\n" +
          "Kérlelték minden este, hogy meséljen még,\n" +
          "ennyi mindent kitalálni nem volt semmiség.\n" +
          "Karmosi Úr nem sokat pihentette tagjait,\n" +
          "a mesék szépen megtöltötték egy könyv lapjait.\n",

        "Karom, Karmosi, Karmosi Úr!\n" +
          "Karom, ki volt csibész, most már tisztelt Úr!\n" +
          "Karom, Karmosi, Karmosi Úr!\n" +
          "Karom, ki volt csibész, most már tisztelt Úr!\n",
      ],
    ],
  },
  {
    nev: "Lapidus és Monopator",
    lyrics: [
      [
        "Élt egyszer egy kis pók, ki Lapidus, névre hallgatott,\n" +
          "öt lába volt, nem nyolc, amennyi másoknak jutott,\n" +
          "hálót szőtt magának, egyedi lett a minta,\n" +
          "büszke volt rá nagyon, mégsem lett hinta.\n",
        "Csúfolta őt a többi pók, nevettek a hálón,\n" +
          "Nem zavarta Lapidust, nem is nézett vádlón.\n" +
          "Hálójába beletévedt a kertnek egyszemű kis bogara,\n" +
          "Monopatorból barát lett, nem pedig finom vacsora.\n" +
          "Így kezdődött Monopator és Lapidus szuper meséje,\n" +
          "együtt lettek három pók, és egy vakond utolsó esélye.\n",
        "Lapidus és Monopator, két jó barát,\n" +
          "hangyák ellen nyertek jó nagy csatát.\n" +
          "Három pók és egy vakond, bővült a társaság,\n" +
          "igaz a történet, ma is mesélik a macskák!\n",
      ],
      [
        "Meglátták, hogy három kis pók a hangyák rabszolgája lett, \n" +
          "elszörnyedtek rögtön, micsoda borzalmas egy tett,\n" +
          "hőseink rögtön az igazság oldalára álltak,\n" +
          "egy jó mentőakciót rögtön kifundáltak!\n" +
          "Kimenekült egy ejtőernyőn az ötfős brigád,\n" +
          "együtt indultak, hogy felépítsék az új hazát.\n" +
          "Közben az öt barát hősiesen vakondot mentett,\n" +
          "és az okos kis Monopator közben generális lett.\n" +
          "Vakondunk hálából helyre kis házat épített,\n" +
          "az öt barát a vízparton végleg letelepedett.\n",
        "Négy pók és az egyszemű kis bogár,\n" +
          "vígan éldegélnek, mindig tele a pohár,\n" +
          "nektárt iszogatnak, vár rájuk a határ!\n" +
          "Ma is barátságban éldegél ez a szuper társaság,\n" +
          "ez az igaz történet ma is mesélik a macskák!\n",
      ],
    ],
  },
  {
    nev: "Vad kalózok dala",
    lyrics: [
      [
        "Az Égszínkék-tenger öblén élt egy csillag, Pacal,\n" +
          "Egy kifőzde volt otthona, ott élt róla szól ez a dal.\n" +
          "Koviubi volt a kukta, Gyöngyhagyma a pincér,\n" +
          "bátrak voltak mindannyian, mint egy hőscincér.\n" +
          "jó sok kalóz étkezett ott, telt a sok feneketlen bendő,\n" +
          "durva népség, kinek nem ismerős az asztalkendő, \n" +
          "sokáig járt kalózkézben az étkezdei kilincs,\n" +
          "de végül mindegyikre rácsattant a bilincs.\n" +
          "Nem érkezett már több vendég ó a kifőzdébe,\n" +
          "Pacaléknak kalózkodás lett a megélhetése.\n",

        "Pacal, Koviubi, Gyöngyhagyma,\n" +
          "legyőzhetetlen vad kalózbanda,\n" +
          "megtépázta őket a vad tenger heves szele,\n" +
          "végül megkerült mindenkinek a méltó helye.\n",
      ],
      [
        "Az újdonsült kalózbanda bátran a nyílt vízre futott,\n" +
          "zsákmány helyett nekik bizony csak szenvedés jutott,\n" +
          "behajóztak barátaink a tengernagy szoros markába,\n" +
          "bezsuppolták a három kalózt egy koszos kamrába.\n" +
          "Nehezen, de a szerencse melléjük meg is érkezett,\n" +
          "a tengernagyi hajón mindenki finomat étkezett.\n" +
          "A sikertelen kalózbanda lerakta a csáklyát,\n" +
          "hajós éttermet nyitottak, egy Fazék nevű bárkát,\n" +
          "jó hírük elterjedt, mint víz felett a füst,\n" +
          "második hajójuk lett az ínycsiklandó Üst.\n" +
          "Ha meglátod valahol az egyik bárkát,\n" +
          "biztos lehetsz benne, hogy sütit kapsz, nem csáklyát.\n",
        "Pacal, Koviubi, Gyöngyhagyma,\n" +
          "legyőzhetetlen vad kalózbanda,\n" +
          "megtépázta őket a vad tenger heves szele,\n" +
          "végül megkerült mindenkinek a méltó helye.\n",
      ],
    ],
  },
  {
    nev: "Tengermélyi kaland",
    lyrics: [
      [
        "Élt egy kis zöld lény ó a tengerfenéken,\n" +
          "vágyakozás csillogott okos kis szemében,\n" +
          "egyedül volt, de szíve társra vágyott,\n" +
          "hasonlóra, melyet a tükörben látott.\n",

        "Megtalálni azt, hogy honnan származhatna,\n" +
          "egy szép napon felült a közeli tengeráramlatra.\n" +
          "Útja során otthonától messzire jutott,\n" +
          "közben sok lénnyel összebarátkozott,\n" +
          "megérkezett végül a nagy Kagylótárba,\n" +
          "belesétált egy öreg polip ölelő csápjába.\n",

        "Ó, a Sekély-tenger, messzire sodor,\n" +
          "hol mindenféle fura lény vígan honol,\n" +
          "Zöldi utazik, útja messzire vezet,\n" +
          "hol a kagylók őríznek számos ősi jelet.\n",

        "Paszomány Sámuel egy öreg polip, szemüveggel.\n" +
          "Felkiáltott: Micsoda csoda, történik itt ma reggel!\n" +
          "Tengeri uborka, ritka vendég, megértem öreg fejjel.\n" +
          "Zöldi maradt, barátság szövődött kettőjük között,\n" +
          "Zöldi egy jó időre Sámuelhez költözött.\n" +
          "Mikor már a honvágy nagyon gyötörte.\n" +
          "Kagylótár egy példányát magával vitte. \n",
      ],

      [
        "Ó, a Sekély-tenger, messzire sodor,\n" +
          "hol mindenféle fura lény vígan honol,\n" +
          "Zöldi utazik, útja messzire vezet,\n" +
          "hol a kagylók őríznek számos ősi jelet.\n",

        "Hazafelé úton testet öltött a remény,\n" +
          "Zöldi mellé társult egy másik kis zöld lény,\n" +
          "Ubellineával ma már egy párt alkotnak,\n" +
          "Vízközjáró géppel sok helyre eljutnak.\n" +
          "Lemerültek oda, hol még senki sosem járt,\n" +
          "jó cimborájuk lett egy késfarkú palavárd.\n" +
          "Egy szuper kaland után hazaindultak,\n" +
          "egy zárt befőttesüvegbe belebotlottak,\n" +
          "benne volt a világ legnagyobb csodája,\n" +
          "így lett bizony soktagú az ubik családja.\n",

        "Ó, a Sekély-tenger, messzire sodor,\n" +
          "hol mindenféle fura lény vígan honol,\n" +
          "Zöldi utazik, útja messzire vezet,\n" +
          "hol a kagylók őríznek számos ősi jelet.\n",
      ],
    ],
  },
  {
    nev: "Kenyérkutya",
    lyrics: [
      [
        "Egy pékség mélyén zsúrkenyér született,\n" +
          "Varázsszél fújt, egy igazi csoda érkezett.\n" +
          "tacskóvá változott egy kis zsúrkenyér,\n" +
          "kiflit dobott utána a mérges péktenyér.\n" +
          "a kifli repült, kutyánk gyorsan elfutott,\n" +
          "végül egy parkban nagyot szundított.\n" +
          "Mindenféle csudát összeálmodott\n" +
          "ébresztőnek egy vízsugarat kapott.\n" +
          "Világgá elindult, mert megtehette,\n" +
          "közben egy ember Hotdognak nevezte.\n",

        "Indulj Hotdog, fusson szíved orrod után,\n" +
          "gyerünk kishaver, ne nézz rám furán,\n" +
          "tacskóléptek szelik majd a földet, s eget,\n" +
          "téged néhány űrlény is barátként emleget.\n",

        "Elindult hát merre az orra vezette,\n" +
          "jószerencse hajtotta, vígan terelte.\n" +
          "Leheveredett bizony éjjel jól a mezőre,\n" +
          "majd egy kossal találkozott, s meg volt lepődve.\n" +
          "Dezső a kos megmutatta a szuper csodát,\n" +
          "űrhajót és űrlényeket, beszélő hangyát.\n" +
          "Indulj Hotdog, fuss a szíved, orrod után,\n" +
          "nyugalom kishaver, senki nem vág kupán.\n" +
          "tacskóléptek szelik majd a földet és eget,\n" +
          "téged néhány űrlény is barátként emleget.\n",
      ],

      [
        "Indulj Hotdog, fusson szíved orrod után,\n" +
          "gyerünk kishaver, ne nézz rám furán,\n" +
          "tacskóléptek szelik majd a földet, s eget,\n" +
          "téged néhány űrlény is barátként emleget.\n",

        "Az űrhajó elrepült, gyorsan felhős lett az ég,\n" +
          "duzzasztópor miatt nedves lett a lég,\n" +
          "Dezső és Hotdog is vizes lett kicsinység.\n" +
          "A tanya hol Dezső élt lett Hotdog otthona,\n" +
          "az élet hozzá bizony nem lett sosem mostoha.\n" +
          "Mindig volt előtte étel, fekhely sok simogatás,\n" +
          "Hotdognak jól sikerült ez a csodás átváltozás.\n",

        "Indulj Hotdog, fusson szíved orrod után,\n" +
          "gyerünk kishaver, ne nézz rám furán,\n" +
          "tacskóléptek szelik majd a földet, s eget,\n" +
          "téged néhány űrlény is barátként emleget.\n",
      ],
    ],
  },
  {
    nev: "Csokoplanéta dala",
    lyrics: [
      [
        "Messze az égben, hol csillagok, édes fénye jár,\n" +
          "Csokoplanéta földjén tejszínhabhegy a határ.\n" +
          "Gumicukor fák hajlanak, zselé folyó tortavölgyben halad,\n" +
          "Sütiemberek békés népe mézeskalácsúton boldogan szalad.\n",

        "Csokoplanéta, csodás békés világ,\n" +
          "fánkhegyek közt ehető minden virág.\n" +
          "Édes álom, méz a házon, fagylalthegycsúcson csokihiúz,\n" +
          "Csokoplanéta, mi terád vágyunk, minden feléd húz!\n",

        "Két nép és király él itt, tejcsokis, étcsokis,\n" +
          "békében élnek ők, nugátszívük nem hamis.\n" +
          "De a forrócsokis mulatságon a szertartásbögre hibádzik,\n" +
          "borzasztó ízek miatt a két békés király nagyot vitázik!\n",

        "Csokoplanéta, csodás békés világ,\n" +
          "fánkhegyek közt ehető minden virág.\n" +
          "Édes álom, méz a házon, fagylalthegycsúcson csokihiúz,\n" +
          "Csokoplanéta, mi terád vágyunk, minden feléd húz!\n",
      ],

      [
        "Gyűlnek a süti-harcosok, cukorkardot rántva,\n" +
          "Linzer-lovagok kevélyen a határcukron állva.\n" +
          "Muffinmatrózok, ádáz habcsókhadnagyok,\n" +
          "levegőben, földön, vízen gyűlnek a csapatok,\n" +
          "tiramimisutüzér, trüffeltizedes és gyömbér-gyalog,\n" +
          "emlegeti mindenki ezt a borzalmas napot.\n" +
          "Párviadal! így szólt a döntés, megindult a küzdelem,\n" +
          "szerencsére megérkezett egy öreg bölcs hirtelen.\n",

        "A királyok ráeszméltek a nagy tévedésre,\n" +
          "egy zsák jó kis cement csalta őket lépre,\n" +
          "békülés lett, s újraindult az ünneplés végre,\n" +
          "a Csokoplanéta szavazott a békességre.\n",

        "Csokoplanéta, csodás békés világ,\n" +
          "fánkhegyek közt ehető minden virág.\n" +
          "Édes álom, méz a házon, fagylalthegycsúcson csokihiúz,\n" +
          "Csokoplanéta, mi terád vágyunk, minden feléd húz!\n",
      ],
    ],
  },
  {
    nev: "Kutyafuttató",
    lyrics: [
      [
        "Legjobb hely a világon, \n" +
          "a kutyafuttató barátom,\n" +
          "az utcavégit ajánlom,\n" +
          "az nincs túl minden határon,\n" +
          "majd mindennap oda dzsanázom,\n" +
          "nem lesznek bogáncsok a bokámon,\n" +
          "finom homokkal van felszórva, \n" +
          "nincs ott rosszakaró perszóna,\n" +
          "hattól kezdődik az ebóra,\n" +
          "nem kell hozzá zsebóra.\n",

        "Futás és kergetőzés mindennap nagyon jó, \n" +
          "bizony nem lesz belőlem ugató zsírgolyó.\n",

        "Érkeznek a gazdáktól az ukázok,\n" +
          "apportíroznak a német juhászok,\n" +
          "futkosnak a bundás betyárok,\n" +
          "itt nincsenek lusta puhányok,\n" +
          "mind üvöltenek, mint a sakálok,\n" +
          "szólnak a gazdáktól a fohászok.\n",

        "Futás és kergetőzés mindennap nagyon jó, \n" +
          "bizony nem lesz belőlem ugató zsírgolyó.\n",
      ],

      [
        "Odajár a Tóth Jánosék masztiffja,\n" +
          "vezeti kislányuk a Franciska,\n" +
          "János bácsi kinek hatalmas a barkója,\n" +
          "követi a lógó fülű tacskója,\n" +
          "Margit néni kinek tarka a ruhája,\n" +
          "hasonló a hosszúlábú uszkárja,\n" +
          "száguldozik az ugató mixtúra,\n" +
          "kutyákból gyúrt színes-szagos textúra.\n",

        "Futás és kergetőzés mindennap nagyon jó, \n" +
          "bizony nem lesz belőlem ugató zsírgolyó.\n",

        "Elfáradtak az ugató zsiványok,\n" +
          "bizony ma sem voltak puhányok,\n" +
          "holnap megyek én is nem kártyázok,\n" +
          "gyertek ti is ne legyetek lekvárok.\n",

        "Futtatóban voltam ma is, jó volt belátom,\n" +
          "holnap te is bandázz velünk, gyere barátom!\n",
      ],
    ],
  },
  {
    nev: "Sajtos hold",
    lyrics: [
      [
        "Este ülök kint a kertben, nézem az égi a lényt,\n" +
          "Hold ragyog fönt az égen, és furcsán int felém,\n" +
          "Kicsi szívem nagyot dobban, szememben vágy ragyog,\n" +
          "bizton tudom, hogy sajtból vagy, belőled jóllakok.\n",

        "Ó, te sajtos fény, te titkos csoda,\n" +
          "ó, te fentről rám tekintő finom lakoma! \n" +
          "Gurulj hozzám fürgén gyorsan, ne légy goromba,\n" +
          "belekerülsz még ma este a pocakomba.\n",

        "Álmaimban felrepülök, fel a sajtos égbe, \n" +
          "elkapom jól ó a Holdat, megkóstolom végre.\n" +
          "De a Hold még oly távol, én meg itt vagyok,\n" +
          "éjjelenként azt álmodom, hogy sajtot falok.\n",
      ],

      [
        "Ó, te sajtos fény, te titkos csoda,\n" +
          "ó, te fentről rám tekintő finom lakoma! \n" +
          "Gurulj hozzám fürgén gyorsan, ne légy goromba,\n" +
          "belekerülsz még ma este a pocakomba.\n",

        "A holdfényben minden csodás, minden olyan szép,\n" +
          "szívem mélyén érezem, hogy ez nem egy álomkép.\n" +
          "Tudom egyszer majd elérlek, és jól megkóstollak,\n" +
          "sajtos falatokkal töltöm meg korgó gyomromat.\n",

        "Ó, te sajtos fény, te titkos csoda,\n" +
          "ó, te fentről rám tekintő finom lakoma! \n" +
          "Gurulj hozzám fürgén gyorsan, ne légy goromba,\n" +
          "belekerülsz még ma este a pocakomba.\n",
      ],
    ],
  },
  {
    nev: "Kukásautó blues",
    lyrics: [
      [
        "Reggel a kertben, ahol a fű zölden terül el,\n" +
          "egy borzas kutya áll, és bőszen fülel,\n" +
          "hallja a zajt, valami közeledik,\n" +
          "kukásautó jön, hallani hangjait.\n",

        "A kutya ugat, csahol hangosan,\n" +
          "a kukásokat nézi, büszkén és haragosan.\n" +
          "Ez az én területem, tűnés innen!\n" +
          "A kukások nevetnek: Nyugi, barátom, minden rendben.\n",

        "A nagy sárga autó lassan megáll,\n" +
          "kutyánk ugat, egy ember kiszáll,\n" +
          "a kukás bácsi kedvesen felé néz,\n" +
          "Nyugi haver, nincs itt semmi vész.\n",
      ],

      [
        "A kukák ürülnek, kutyánk nézi őket,\n" +
          "még kicsit morog, de közben farkat pörget,\n" +
          "talán nem is rosszak, csak teszik a dolgukat,\n" +
          "gondolja kutyánk és csak halkan ugat.\n",

        "A kutya ugat, csahol hangosan,\n" +
          "a kukásokat nézi, büszkén és haragosan.\n" +
          "Ez az én területem, tűnés innen!\n" +
          "A kukások nevetnek: Nyugi, barátom, minden rendben.\n",

        "A kukásautó elmegy, a nap süt tovább lágyan,\n" +
          "kutyánk megnyugszik, és eldől puha fű ágyban,\n" +
          "szuper új barátság indult el a mai nappal,\n" +
          "jó fejek a kukások, induljunk tiszta lappal.\n",
      ],
    ],
  },
  {
    nev: "Kutya-macska barátság",
    lyrics: [
      [
        "A padláson lakott egy huncut kis macska,\n" +
          "foltos volt bundája és elálló kis bajsza,\n" +
          "a házőrző kutya sokszor megkergette,\n" +
          "macskánk ok nélkül sokszor ingerelte.\n",

        "Macska és kutya, általában civakodnak,\n" +
          "de ha baj történik, sokszor összefognak,\n" +
          "onnantól lesznek ők igazi jó komák,\n" +
          "megtörténnek néha az ilyen csodák.\n",

        "Egy nap a macseknak megfájdult a lába,\n" +
          "házőrzőnk odament, a farkát csóválva.\n" +
          "Gyere, kishaver, segítek most neked.\n" +
          "Macskán felnézett, s hálát rebegett.\n" +
          "Két hősünk e-naptól kezdve összefogott,\n" +
          "megosztottak egymással ki mit tudott.\n",

        "Macska és kutya, kik sokszor vitáztak,\n" +
          "innentől kezdve, egymásra vigyáztak,\n" +
          "bajban lettek ők igazi jó komák,\n" +
          "megtörténnek néha az ilyen csodák.\n",
      ],

      [
        "Összeugranak néha egy-egy dolgon,\n" +
          "a párnán, vagy finom ízes koncon,\n" +
          "este elalszanak együtt békében,\n" +
          "a két barát elszuszog szépen.\n",

        "Macska és kutya, kik sokszor vitáztak,\n" +
          "innentől kezdve, egymásra vigyáztak,\n" +
          "bajban lettek ők igazi jó komák,\n" +
          "megtörténnek néha az ilyen csodák.\n",

        "Reggel a nap melegen süt, felkel a két jóbarát, \n" +
          "a cica nyújtózkodik, a kutya csóválja a farkát,\n" +
          "bár különböznek, mégis így kerek a világ,\n" +
          "a barátság összeköt, azóta kerülik a vitát.\n",
      ],
    ],
  },
  {
    nev: "A keverék kutya dala",
    lyrics: [
      [
        "Keverék kutya, te vagy a sztár,\n" +
          "az élet vidám, veled nincs határ,\n" +
          "bundád tarkabarka, mint egy szép festmény,\n" +
          "polcról rám kacsintó szuper képregény,\n" +
          "rád tekintve érzem elönt a remény,\n" +
          "veled a játék sosem lesz kemény!\n",

        "Keverék kutya, te vagy a legjobb\n" +
          "ha látlak téged az mindig feldob\n" +
          "szaladjunk együtt, legyen nagy a móka,\n" +
          "te vagy a hősöm, neked szól a nóta!\n",

        "Füled összevissza, és néha lelóg,\n" +
          "engem szórakoztatsz, ez a te melód,\n" +
          "hűséges társ vagy, legjobb cimbora,\n" +
          "együtt vár minket kalandok sora!\n",

        "Keverék kutya, te vagy a legjobb,\n" +
          "ha látlak téged az mindig feldob,\n" +
          "szaladjunk együtt, legyen nagy a móka,\n" +
          "te vagy a hősöm, neked szól a nóta!\n",
      ],

      [
        "Keverék kutya, kedves barátom,\n" +
          "veled átmennék minden határon,\n" +
          "bárhová megyünk, velünk jön a móka,\n" +
          "örömmel tölt el, hogy nem lettél fóka!\n",

        "Keverék kutya, te vagy a legjobb\n" +
          "ha látlak téged az mindig feldob\n" +
          "szaladjunk együtt, legyen nagy a móka,\n" +
          "te vagy a hősöm, neked szól a nóta!\n",

        "Keverék kutya, Te vagy a legjobb barát,\n" +
          "együtt nyomulunk, bírjuk a strapát,\n" +
          "szaladunk, futunk, kéz a mancsban,\n" +
          "ketten vagyunk egy szuper brancsban.\n",
      ],
    ],
  },
  {
    nev: "Az örökbefogadás",
    lyrics: [
      [
        "Egykor az utcán, céltalan bolyongtam,\n" +
          "korgó gyomorral fal mellett osontam,\n" +
          "a gazdám kidobott, mert sokat ugattam,\n" +
          "végül egy szűkös menhelyre jutottam.\n",

        "Most egy tanyán élek, szabadban hálok,\n" +
          "körbe-körbe ugrándozom, vígan kiabálok,\n" +
          "vigyázom a területet, védek és őrzök,\n" +
          "ha gyerekek jönnek, örömökben fürdök.\n",

        "Új otthonomban minden az enyém,\n" +
          "a mezők illata vígan száll felém,\n" +
          "nincs több zár, se ketrec, se lánc,\n" +
          "korlátok nélkül szabad a tánc.\n",

        "Mindegy, hogy reggel vagy éj,\n" +
          "itt minden perc egy igazi kéj,\n" +
          "vigyázok mindenre, mert ez a parancs,\n" +
          "felesküdött erre ez a négy erős mancs.\n",
      ],

      [
        "Most egy tanyán élek, szabadban hálok,\n" +
          "körbe-körbe ugrándozom, vígan kiabálok,\n" +
          "vigyázom a területet, védek és őrzök,\n" +
          "ha gyerekek jönnek, örömökben fürdök.\n",

        "Nem cserélek senkivel, ez az én világom,\n" +
          "beteljesült végre a sok menhelyi álmom,\n" +
          "Egy tanyán élek, mert örökbe fogadtak,\n" +
          "a gazdáék nekem szuper új életet adtak.\n",

        "Most egy tanyán élek, szabadban hálok,\n" +
          "körbe-körbe ugrándozom, vígan kiabálok,\n" +
          "vigyázom a területel, védek és őrzök,\n" +
          "ha gyerekek jönnek, örömökben fürdök.\n",
      ],
    ],
  },
];

export default music;
